import { isEmpty, get } from 'lodash';
import { getReferralCode } from './localStorage';

/**
 * Get the referral code with fallback strategy:
 * 1. Try mwr param from URL
 * 2. Try localStorage
 *
 * @returns {string|null} The referral code or null
 */
export const getReferralCodeWithFallback = (location = {}) => {
  // First, try get mwr params from url (most reliable)
  if (!isEmpty(location)) {
    const params = new URLSearchParams(get(location, 'search', ''));

    if (params.get('mwr')) {
      return params.get('mwr');
    }
  }

  // Second, try localStorage
  const storedCode = getReferralCode();
  if (storedCode) {
    return storedCode;
  }

  return null;
};
